import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {Map as ImmutableMap} from 'immutable';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const LacerationDetails = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex ?? 0, 0);

  const isGVA6Plan =
    getQuoteFieldValue<ImmutableMap<string, any>>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}]`)?.get(
      'planCd'
    ) === 'GVA6';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'laceration-details-row-1'},
      items: [
        {
          key: propertyPaths.lacerationDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={isGVA6Plan ? 'Incurral Period (Days)' : 'Incurral Period (Hours)'}
              value={getQuoteFieldValue<number>(propertyPaths.lacerationDetails.incurralPeriod)}
              id={propertyPaths.lacerationDetails.incurralPeriod}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.lacerationDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormElement
              elementType="FormControl"
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              checked={getQuoteFieldValue<boolean>(propertyPaths.lacerationDetails.customizeBenefitAmount)}
              id={propertyPaths.lacerationDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'laceration-details-row-2'},
      items: [
        {
          key: propertyPaths.lacerationDetails.withoutRepairAmount,
          hidden: isGVA6Plan,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Without Repair"
              adornment="money"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.lacerationDetails.withoutRepairAmount)
              )}
              disabled
              id={propertyPaths.lacerationDetails.withoutRepairAmount}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.lacerationDetails.lacerationLength1Amount,
          hidden: isGVA6Plan,
          element: (
            <QuoteFormElement
              elementType="Text"
              label='Repaired under 2" long'
              adornment="money"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.lacerationDetails.lacerationLength1Amount)
              )}
              disabled
              required
              id={propertyPaths.lacerationDetails.lacerationLength1Amount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'laceration-details-row-3'},
      items: [
        {
          key: propertyPaths.lacerationDetails.lacerationLength2Amount,
          hidden: isGVA6Plan,
          element: (
            <QuoteFormElement
              elementType="Text"
              label='Repaired 2" to 6" long'
              adornment="money"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.lacerationDetails.lacerationLength2Amount)
              )}
              disabled
              id={propertyPaths.lacerationDetails.lacerationLength2Amount}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.lacerationDetails.lacerationLength3Amount,
          hidden: isGVA6Plan,
          element: (
            <QuoteFormElement
              elementType="Text"
              label='Repaired over 6" long'
              adornment="money"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.lacerationDetails.lacerationLength3Amount)
              )}
              disabled
              id={propertyPaths.lacerationDetails.lacerationLength3Amount}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'laceration-details-row-3'},
      items: [
        {
          key: propertyPaths.lacerationDetails.benefitAmount,
          hidden: !isGVA6Plan,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(getQuoteFieldValue<number>(propertyPaths.lacerationDetails.benefitAmount))}
              disabled
              id={propertyPaths.lacerationDetails.benefitAmount}
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.lacerationDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Number of Times Benefit is Payable per Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.lacerationDetails.maxBenefitNumber)}
              disabled
              id={propertyPaths.lacerationDetails.maxBenefitNumber}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.lacerationDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.lacerationDetails.timePeriodCd)}
              disabled
              id={propertyPaths.lacerationDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
